import type { AuthResult, VercelRunner } from '@cli-types/next-adapter/vercel.js'
import { WHOAMI_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { runVercel } from '../runner/run-vercel.js'

export async function checkVercelAuth(
  runner: VercelRunner,
  cwd: string,
  env?: NodeJS.ProcessEnv
): Promise<AuthResult> {
  const result = await runVercel(runner, ['whoami'], {
    cwd,
    mode: 'capture',
    timeoutMs: WHOAMI_TIMEOUT_MS,
    env
  })

  if (result.success) {
    const username = result.stdout.trim().split('\n').pop()?.trim()
    return { authed: true, username: username || undefined }
  }

  return { authed: false, reason: result.timedOut ? 'timeout' : 'not-authed' }
}
